<template>
    <aside class="menu desktop-menu">
        <!-- Content to be displayed in the branding section -->
        <slot name="branding" />

        <header
            v-if="$slots.header"
            class="menu-header"
        >
            <!-- Content to be displayed in the header section -->
            <slot name="header" />
        </header>

        <div class="menu-body">
            <!-- Content to be displayed in the main section -->
            <slot />
        </div>
    </aside>
</template>

<script>
    /**
     * @group Layout
     * A component to display a Menu.
     * This component can be used in conjunction with `MobileMenu.vue` to create a responsive navigation.
     * To make this a responsive component, additional styling will be needed. Review the markup examples found in
     * Full Layout for implementation.
     */
    export default {
        name: 'Menu'
    };
</script>
